import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function ArrowUpOutlineIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    d: "M4.99982 11.5884L11.0069 5.58138V21.7437H13.0067V5.57034L18.9959 11.5594L20.4102 10.1452L12.0123 1.74754L3.58559 10.1742L4.99982 11.5884Z",
    fill: "currentColor"
  }));
}